// The one support line shown across Chain29 (owner, Oct 28 2026).
export const SUPPORT_PHONE = '877-670-4319';
export const SUPPORT_PHONE_TEL = 'tel:+18776704319';
export const SUPPORT_EMAIL = 'support@asterpos.com';
